import { CalendarDays, MapPin, Sprout } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/api";

export const UsageRing = ({ used, limit }) => {
  const pct = Math.min(used / limit, 1);
  const r = 52, circ = 2 * Math.PI * r;
  return (
    <div className="relative h-36 w-36" data-testid="member-usage-ring">
      <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90">
        <circle cx="60" cy="60" r={r} strokeWidth="12" className="stroke-white/15 fill-none" />
        <circle cx="60" cy="60" r={r} strokeWidth="12" strokeLinecap="round" stroke="url(#g)" className="fill-none" strokeDasharray={circ} strokeDashoffset={circ * (1 - pct)} style={{ transition: "stroke-dashoffset 1s ease" }} />
        <defs><linearGradient id="g"><stop offset="0%" stopColor="#10B981" /><stop offset="100%" stopColor="#F59E0B" /></linearGradient></defs>
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div><p className="font-display text-3xl font-extrabold" data-testid="member-intros-remaining">{Math.max(limit - used, 0)}</p><p className="text-xs font-semibold opacity-75">remaining</p></div>
      </div>
    </div>
  );
};

export const IntroList = ({ intros }) => (
  <div className="space-y-4" data-testid="member-intro-list">
    {intros.length === 0 && (
      <div className="rounded-2xl border border-dashed border-border p-10 text-center text-muted-foreground" data-testid="member-intros-empty">
        <Sprout className="h-8 w-8 mx-auto text-primary mb-2" />Your first farm introduction is being arranged. We'll email you as soon as it's scheduled.
      </div>
    )}
    {intros.map((i) => (
      <div key={i.id} className="rounded-2xl border border-border bg-card p-5 hover:border-primary/60 transition-colors" data-testid={`member-intro-${i.id}`}>
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="font-display text-lg font-bold">{i.farm_name}</p>
            <p className="text-sm text-muted-foreground">{i.farm_region}</p>
          </div>
          <StatusBadge status={i.status} testId={`member-intro-status-${i.id}`} />
        </div>
        <div className="mt-4 grid gap-2 sm:grid-cols-2 text-sm">
          <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-primary" />{i.meetup_location}</p>
          <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-amber-500" />{fmtDate(i.scheduled_at)}</p>
        </div>
        {i.details && <p className="mt-3 text-sm text-muted-foreground whitespace-pre-wrap">{i.details}</p>}
      </div>
    ))}
  </div>
);
